import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, getFormValues } from "redux-form";
import _ from "lodash";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import {
  CheckCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import { updateTicketAssignedAttendee } from "@ticketsaction";
import { classNames } from "@utilscommon";
import SessionRSVP from "@rsvpsessionsfield";
import LocaleStrings from "@language";

const SessionAssign = (props) => {
  const {
    // Parent
    assign,
    ticketinfo,
    source,
    ticketSessionSettings = {},

    // Own
    eventSettingsData,
    handleSubmit,
    autofill,
    formValues,
    assignedAttendeeTickets,
  } = props;
  const [loading, setLoading] = useState(false);
  const [openContent, setContentOpen] = useState(true);
  const rsvpsessions = formValues?.rsvpsessions ?? [];
  const sessionRSVPPage = ticketinfo?.rsvpsessions ?? [];
  const custom_settings = JSON.parse(
    eventSettingsData?.data?.custom_settings ?? "{}"
  );
  const rsvpMandatory = custom_settings?.rsvp_mandatory ?? false;
  const allowRSVP = ticketSessionSettings?.allowrsvp ?? true; // Session RSVP restriction
  const maxSessionRSVP = ticketSessionSettings?.maxsessionrsvp ?? ""; // Session RSVP max limit
  // console.log("assign :- ", assign);
  // console.log("ticketinfo :- ", ticketinfo);
  // console.log("sessionRSVPPage :- ", sessionRSVPPage);
  // console.log("assignedAttendeeTickets :- ", assignedAttendeeTickets);

  const onSubmitForm = (data) => {
    // console.log("data :- ", data);
    let assigned = JSON.parse(JSON.stringify(assignedAttendeeTickets));
    let tid = ticketinfo?.ticketid;
    let email = assign?.email;
    let index = assign?.index;
    let assignedTid = assigned?.[tid] ?? [];
    // console.log("assignedTid :- ", assignedTid);

    let values = data?.rsvpsessions;
    let error = validate(data, props);
    if (!_.isEmpty(error)) {
      return;
    }

    let checkIndex = _.findIndex(assignedTid, (o) => {
      return o.ticketid === tid && o.email === email && o.index === index;
    });
    let object = { ...assignedTid[checkIndex], rsvpsessions: values };
    assigned[tid][checkIndex] = object;

    // console.log("assigned :- ", assigned);
    // console.log("check :- ", object);

    setLoading(true);
    props.updateTicketAssignedAttendee(assigned);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handleAccordion = () => {
    if (openContent) {
      setContentOpen(false);
    } else {
      setContentOpen(true);
    }
  };

  const renderSessionRSVPValidation = () => {
    const displaySessionRSVPInfo =
      !allowRSVP ||
      (maxSessionRSVP !== "" &&
        rsvpsessions.length >= parseInt(maxSessionRSVP));

    let warningText = "";
    if (!allowRSVP) {
      warningText =
        ticketSessionSettings?.allowstatus === "not_started"
          ? LocaleStrings.kRSVPSessionNotStartedForCurrentTicketText.replace(
              "###STARTTIME###",
              `<b>${ticketSessionSettings?.starttime}</b>`
            )
          : LocaleStrings.kRSVPSessionEndedForCurrentTicketText.replace(
              "###ENDTIME###",
              `<b>${ticketSessionSettings?.endtime}</b>`
            );
    } else if (
      maxSessionRSVP !== "" &&
      rsvpsessions.length >= parseInt(maxSessionRSVP)
    ) {
      warningText =
        LocaleStrings.kRSVPSessionForCurrentTicketMaxLimitText.replace(
          "###MAXLIMIT###",
          `<b>${maxSessionRSVP}</b>`
        );
    }

    return (
      <>
        {displaySessionRSVPInfo ? (
          <div className="flex gap-2">
            <InformationCircleIcon className="custom-text-theme-sm-medium w-5 h-5" />
            <div
              className="custom-text-theme-sm-medium"
              dangerouslySetInnerHTML={{ __html: warningText }}
            />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      <li className="rounded-md border border-default">
        <div
          className="py-4 px-4 flex items-center justify-between border-b cursor-pointer"
          onClick={handleAccordion}
        >
          <div className="flex items-center space-x-4">
            <div>
              <CheckCircleIcon className="w-6 h-6" />
            </div>
            <div className="flex space-x-1.5">
              {ticketinfo?.haschild ? (
                <span className="custom-text-primary-md-bold">
                  #{assign?.position}
                </span>
              ) : (
                <>
                  {ticketinfo?.quantity > 1 ? (
                    <span className="custom-text-primary-md-bold">
                      #{assign?.position}
                    </span>
                  ) : (
                    ""
                  )}
                </>
              )}
              <div>
                <div className="custom-text-primary-md-normal">
                  {ticketinfo?.name}
                  {rsvpMandatory && allowRSVP && (
                    <span className="label-mandatory">*</span>
                  )}
                </div>
                <div className="custom-text-secondary-sm-normal">
                  {assign?.email}
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            {openContent ? (
              <ChevronUpIcon className="w-5 h-5" />
            ) : (
              <ChevronDownIcon className="w-5 h-5" />
            )}
          </div>
        </div>

        {/* content */}
        <div className={`${openContent ? "" : "hidden"}`}>
          <>
            <div className="bg-default px-4 py-4">
              {/* Form section */}
              <form onSubmit={handleSubmit(onSubmitForm)}>
                <div className="base-form">
                  {/* Display any setting validation info for session RSVP */}
                  {renderSessionRSVPValidation()}

                  <SessionRSVP
                    source={source}
                    ticketSessionSettings={ticketSessionSettings}
                    autofill={autofill}
                    formValues={formValues}
                    RSVPSessionsData={sessionRSVPPage}
                    eventSettingsData={eventSettingsData?.data}
                    onChange={() => onSubmitForm(formValues)}
                  />
                </div>

                {/* <div className="mt-4">
                  <button
                    type="submit"
                    className="theme-button-outer-md w-full"
                    disabled={loading}
                  >
                    <svg
                      className={classNames(
                        loading ? "" : "hidden",
                        "cust-btn-spinner"
                      )}
                      viewBox="0 0 1024 1024"
                      focusable="false"
                      data-icon="btnloading"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                    </svg>{" "}
                    {LocaleStrings.kSaveText}
                  </button>
                </div> */}
              </form>
            </div>
          </>
        </div>
      </li>
    </>
  );
};

const validate = (values, ownProps) => {
  let errors = {};
  const sessionRSVPPage = ownProps?.ticketinfo?.rsvpsessions ?? [];
  const ticketSessionSettings = ownProps?.ticketSessionSettings;
  const custom_settings = JSON.parse(
    ownProps?.eventSettingsData?.data?.custom_settings ?? "{}"
  );
  const rsvpMandatory = custom_settings?.rsvp_mandatory ?? false;
  const allowRSVP = ticketSessionSettings?.allowrsvp ?? true; // Session RSVP restriction

  if (sessionRSVPPage?.length > 0 && rsvpMandatory && allowRSVP) {
    let rsvpsessions = values?.rsvpsessions ?? [];
    if (rsvpsessions?.length === 0) {
      errors["rsvpsessionserror"] = LocaleStrings.kFieldRequired;
    }
  }
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  let assign = ownProps?.assign;
  let ticketinfo = ownProps?.ticketinfo;
  let tid = ticketinfo?.ticketid;
  let email = assign?.email;
  let index = assign?.index;
  // console.log("assignedAttendeeTickets :- ", state.assignedAttendeeTickets);

  let init = {};

  if (state.assignedAttendeeTickets[tid]) {
    let checkIndex = _.findIndex(state.assignedAttendeeTickets[tid], (o) => {
      return o.ticketid === tid && o.email === email && o.index === index;
    });

    let rsvpSessions = ticketinfo?.rsvpsessions;
    if (checkIndex >= 0 && rsvpSessions?.length > 0) {
      let userRSVPSessions =
        state.assignedAttendeeTickets[tid][checkIndex]?.rsvpsessions ?? [];
      userRSVPSessions = userRSVPSessions.map((i) => Number(i));
      // console.log("userRSVPSessions :- ", userRSVPSessions);

      let selectedSessions = [];
      let markedSessions = [];
      _.map(rsvpSessions, (ses) => {
        let sesid = ses?.sessionid;
        let index = _.indexOf(userRSVPSessions, parseInt(sesid));
        if (index > -1) {
          markedSessions.push(true);
          selectedSessions.push(sesid);
        } else {
          markedSessions.push(false);
        }
      });
      init.rsvpsessions = selectedSessions;
      init.markrsvp = markedSessions;
    }
  }
  // console.log("init :- ", init);

  return {
    initialValues: init,
    eventSettingsData: state.eventSettingsData,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
    generalRSVPSessions: state.generalRSVPSessions.data || [],

    formValues: getFormValues(ownProps.form)(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ updateTicketAssignedAttendee }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(SessionAssign)
);
